/*
 * Copyright 2023 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { GitLabIntegrationConfig } from './config';
import { GitlabCredentials, GitlabCredentialsProvider } from './types';

export class SingleInstanceGitlabCredentialsProvider
  implements GitlabCredentialsProvider
{
  static create: (
    config: GitLabIntegrationConfig,
  ) => GitlabCredentialsProvider = config => {
    return new SingleInstanceGitlabCredentialsProvider(config.token);
  };

  private constructor(private readonly token?: string) {}

  async getCredentials(_opts: { url: string }): Promise<GitlabCredentials> {
    if (!this.token) {
      return {};
    }

    return {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
      token: this.token,
    };
  }
}
